import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { COURSES, TYPE_GROUPS } from "@/lib/directory";

export const Pick = ({ value, onChange, options, testid, placeholder }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="bg-white" data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      {options.map((o) => <SelectItem key={o.value} value={o.value} data-testid={`${testid}-opt-${o.value}`}>{o.label}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const DirectoryFilters = ({ f, set, states, subjects }) => {
  const subjectOpts = [{ value: "all", label: "All PG subjects" },
    ...subjects.map((s) => ({ value: s.name, label: `${s.degree} · ${s.name}` }))];
  const stateOpts = [{ value: "all", label: "All states (India)" },
    ...states.map((s) => ({ value: s.slug, label: `${s.state} (${s.count})` }))];
  return (
    <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-6" data-testid="directory-filters">
      <div className="relative lg:col-span-2">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[color:var(--ayur-mute)]" />
        <Input value={f.q} onChange={(e) => set({ q: e.target.value })} placeholder="Search college, city, district, ID…"
          className="pl-9 bg-white" data-testid="directory-search-input" />
      </div>
      <Pick value={f.state || "all"} onChange={(v) => set({ state: v === "all" ? "" : v })} options={stateOpts} testid="directory-state-select" />
      <Pick value={f.course} onChange={(v) => set({ course: v, subject: "all" })} options={COURSES} testid="directory-course-select" />
      <Pick value={f.subject} onChange={(v) => set({ subject: v })}
        options={subjectOpts.filter((o) => o.value === "all" || !["md", "ms"].includes(f.course) || subjects.find((s) => s.name === o.value)?.degree === f.course.toUpperCase())}
        testid="directory-subject-select" />
      <Pick value={f.type} onChange={(v) => set({ type: v })} options={TYPE_GROUPS} testid="directory-type-select" />
    </div>
  );
};
